
import { granjaApi } from "../../api";
import { usePlanillassStore } from "../../store";

import Swal from "sweetalert2";





export const startCarguerosXPlanilla = async(id) => {
    try {
        const { data } = await granjaApi.get(`/carguero/xplanilla/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}


